import type { GridCard } from '@Components/BigBrowse/Model/Classes/GridCard';
import type {
  CameraProps,
  PlaneSize,
  PlaneTypes,
  Position2D,
} from '@Components/BigBrowse/Model/ModelTypes';
import { getSingleSectionHeroSpecs } from '@Components/BigBrowse/Views/DetailViews/SingleSectionView/singleSectionRenderer';

import { getMultiSectionMainHeroSpecs } from './MultiSectionView/header/common/getMultiSectionMainHeroSpecs';

import type { JourneyParameters } from '~types/navigation';

export const USE_MULTI_SECTION_FOR_PRODUCT_SET = true;

export const getTargetHeroSpecs = (
  destination: JourneyParameters,
  camera: CameraProps,
  hero: GridCard<PlaneTypes>
): { worldPosition: Position2D; size: PlaneSize } =>
  USE_MULTI_SECTION_FOR_PRODUCT_SET || destination.journey === 'productset'
    ? getMultiSectionMainHeroSpecs(camera, hero)
    : getSingleSectionHeroSpecs(camera);
